import { render, staticRenderFns } from "./MySection.vue?vue&type=template&id=5169b227&scoped=true&"
import script from "./MySection.vue?vue&type=script&lang=js&"
export * from "./MySection.vue?vue&type=script&lang=js&"
import style0 from "./MySection.vue?vue&type=style&index=0&id=5169b227&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5169b227",
  null
  
)

export default component.exports